import React from "react";
import Button from "@material-ui/core/Button";

export default ({ props: cProps, to: to, text: text, ...rest }) =>
    <Button onClick={() => {cProps.history.push(to)}} {...rest}>
        {text}
    </Button>
